import { IObjectAudit } from "../../../models"

export interface ITaskDocument {
    Id: string
    Context: string
    Title: string
    Description: string
    AssignmentDate: string | Date
    DueDate: string | Date
    Required: boolean
    RequireSignature: boolean
    SignatureURL: string
    SignatureSourceIPAddress: string
    SignatureDateTime: string | Date
    RequireSignaturePrintedName: boolean
    SignaturePrintedName: string
    AssignedToUserId: string
    AssignedToName: string
    AssigneeUserId: string
    AssigneeName: string
    SendTaskReminder: boolean
    TaskType: IWorkflowTaskType
    RequireAssigneeVerification: boolean
    Deleted: boolean
    TicksSinceChange: number
    SendReminder: boolean
    RemindDaysPriorToDue: number
    ObjectAudit: IObjectAudit
    Order: number
    AssignToRole: ETaskRole
    AssignByRole: ETaskRole
    DaysDueAfterAssignment: number
    Completed: boolean
    CompletedDate: string
}

export interface IWorkflowTaskType {
    TaskType: EWorkflowTaskTypeEnum
    TaskTypeName: string
    TaskData1: string
    TaskData2: string
    TaskData3: string
    TaskData4: string
}

export enum ETaskRole {
    Employee,
    Recruiter,
    Compliance,
    Supervisor,
    Payroll
}

export enum EWorkflowTaskTypeEnum {
    StandardTask = 0,
    FileRequest = 1,
    PDFFormFill = 2,
    TaskletForm = 3,
    ChecklistItem = 4,
    IntercomTourTrigger = 5,
    TextMobileIntro = 6,
    InviteTeamMembers = 7,    
    YouTube = 8,    
}